module.exports = "<div id=\"tradingviewContainer\">\n</div>"